import { Button, Result, Typography } from "antd";
import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
	children: ReactNode;
	onReset?: () => void;
}

interface State {
	hasError: boolean;
	error: Error | null;
}

const { Text } = Typography;

export class ErrorBoundary extends Component<Props, State> {
	state: State = { hasError: false, error: null };

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
		// Error logging - bu yerda error tracking service ga yuborish mumkin
	}

	handleReset = () => {
		this.setState({ hasError: false, error: null });
		this.props.onReset?.();
	};

	render() {
		if (this.state.hasError) {
			return (
				<Result
					status="error"
					title="Xatolik yuz berdi"
					subTitle={
						import.meta.env.DEV && this.state.error
							? this.state.error.message
							: "Iltimos, sahifani yangilang yoki administrator bilan bog'laning."
					}
					extra={
						<div className="flex gap-2">
							<Button type="primary" onClick={() => window.location.reload()}>
								Sahifani yangilash
							</Button>
							<Button onClick={this.handleReset}>Qayta urinish</Button>
						</div>
					}
				>
					{import.meta.env.DEV && this.state.error?.stack && (
						<div className="mt-4 text-left">
							<Text type="secondary" className="text-xs font-mono whitespace-pre-wrap">
								{this.state.error.stack}
							</Text>
						</div>
					)}
				</Result>
			);
		}
		return this.props.children;
	}
}
